import { render, staticRenderFns } from "./HeaderColumnKanban.vue?vue&type=template&id=50145300&"
import script from "./HeaderColumnKanban.vue?vue&type=script&lang=js&"
export * from "./HeaderColumnKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports